// extracted by mini-css-extract-plugin
export default {"element":"Ticker-module--element--9eb08","container":"Ticker-module--container--b1227","link":"Ticker-module--link--59bc6"};